module.exports = __webpack_public_path__ + "static/media/icon-operational-procedure.fa9b0178.svg";